import Vue from 'vue';

export default Vue.extend({
  props: {
    page: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  computed: {
    numPages(): number {
      return Math.ceil(this.total / this.perPage);
    },
    isFirstPage(): boolean {
      return (this.page === 1);
    },
    isLastPage(): boolean {
      return (this.page === this.numPages);
    },
    firstResult(): number {
      return ((this.page - 1) * this.perPage) + 1;
    },
    lastResult(): number {
      const lastResult = this.page * this.perPage;
      return (lastResult >= this.total) ? this.total : lastResult;
    },
  },
  methods: {
    prevPage(): void {
      this.changePage(this.page - 1);
    },
    nextPage(): void {
      this.changePage(this.page + 1);
    },
    changePage(newPage: number): void {
      this.$emit('changed', {
        page: newPage,
        offset: (newPage - 1) * this.perPage,
      });
    },
  },
});
